import { useContext } from "react";
import AuthContext from "../components/context/AuthContext";

const useGroupMemberships = () => {
  const authCtx = useContext(AuthContext);

  const groupMemberships = {
    isAuditorContractor: authCtx?.user?.groupMemberships?.includes(
      "COLLECTOR_AUDITOR_CONTRACTORS"
    ),
    isAuditorSplicer: authCtx?.user?.groupMemberships?.includes(
      "COLLECTOR_AUDITOR_SPLICERS"
    ),
    isAuditPrimary: authCtx?.user?.groupMemberships?.includes(
      "COLLECTOR_AUDIT_PRIMARY"
    ),
    isPrimary: authCtx?.user?.groupMemberships?.includes("COLLECTOR_PRIMARY"),
    isReadOnly: authCtx?.user?.groupMemberships?.includes(
      "COLLECTOR_USER_READONLY"
    ),
    isUser: authCtx?.user?.groupMemberships?.includes("COLLECTOR_USER"),
    isUserAEG: authCtx?.user?.groupMemberships?.includes("COLLECTOR_USER_AEG"),
    isUserInternational: authCtx?.user?.groupMemberships?.includes(
      "COLLECTOR_USER_INTERNATIONAL"
    ),
    seeINHS:
      authCtx?.user?.groupMemberships?.includes("COLLECTOR_AUDIT_PRIMARY") ||
      authCtx?.user?.groupMemberships?.includes("COLLECTOR_AUDITOR_SPLICERS"),
  };

  return groupMemberships;
};

export default useGroupMemberships;
